//#region mobile-nav
import {
    faBedFront,
    faBus,
    faPlane,
    faTaxi,
    faTrainSubway,
    faCirclePlus as faCirclePlusSolid,
    faTicket as faTicketSolid,
    faHome as faHomeSolid,
    faUser as faUserSolid,
    faCirclePlus,
    faTicket,
    faHome,
    faUser,
} from '@fortawesome/pro-regular-svg-icons';

export const drawerMobileNavWhiteList = [
    '/reserve/',
    '/flights/',
    '/trains/',
    '/buses/',
    '/taxi/',
    '/hotel/',
    '/after-order/transporter',
];

export const services = [
    {
        label: 'بلیط هواپیما',
        icon: faPlane,
        href: '/plane-ticket',
    },
    {
        label: 'رزرو هتل',
        icon: faBedFront,
        href: '/hotel',
    },
    {
        label: 'بلیط قطار',
        icon: faTrainSubway,
        href: '/train-ticket',
    },
    {
        label: 'بلیط اتوبوس',
        icon: faBus,
        href: '/bus-ticket',
    },
    {
        label: 'بلیط سواری',
        icon: faTaxi,
        href: '/taxi',
    },
];

export const navOptions = [
    {
        href: '/',
        icon: faHome,
        activeIcon: faHomeSolid,
        label: 'خانه',
    },
    {
        href: '/services',
        icon: faCirclePlus,
        activeIcon: faCirclePlusSolid,
        label: 'سفر جدید',
    },
    {
        href: '/panel/reserves',
        icon: faTicket,
        activeIcon: faTicketSolid,
        label: 'بلیط‌های من',
    },
    {
        href: '/profile',
        icon: faUser,
        activeIcon: faUserSolid,
        label: 'حساب کاربری',
    },
];

//#endregion
